import { api, requireAccount, withAccount } from "./core";

// disclosureApi is the member self-service D-05 consent gate. A member
// toggles their OWN disclosure for the galaxy they're viewing — galaxy
// scope is carried on the path (account_login), so accountLogin MUST be
// derived from useParams().account (galaxy URL truth). Consent is
// revocable anytime: disclose:false reverts the member to Observation.
export const disclosureApi = {
  getConsent: (accountLogin: string) =>
    api.get<{ disclosed: boolean }>(
      withAccount("/disclosure/consent", requireAccount(accountLogin, "disclosureApi.getConsent")),
    ),
  setConsent: (accountLogin: string, disclose: boolean) =>
    api.post<{ disclosed: boolean }>(
      withAccount("/disclosure/consent", requireAccount(accountLogin, "disclosureApi.setConsent")),
      { disclose },
    ),
  // D-07 self-service visibility (separate axis from consent): "full" lets
  // consent govern, "anonymized" forces Observation, "redacted" hides the
  // member entirely. Same galaxy scope as consent (account_login on the path).
  getVisibility: (accountLogin: string) =>
    api.get<{ visibility: UserVisibility }>(
      withAccount("/disclosure/visibility", requireAccount(accountLogin, "disclosureApi.getVisibility")),
    ),
  setVisibility: (accountLogin: string, visibility: UserVisibility) =>
    api.post<{ visibility: UserVisibility }>(
      withAccount("/disclosure/visibility", requireAccount(accountLogin, "disclosureApi.setVisibility")),
      { visibility },
    ),
  // Unified self presence: the single public/private toggle the settings page
  // binds to. The server composes consent + D-07 visibility so `public:false`
  // hides the member on EVERY surface (module topology included) and holds even
  // when they hold a paid seat — the D-07 clamp overrides the seat. Reversible.
  getSelfPresence: (accountLogin: string) =>
    api.get<{ public: boolean }>(
      withAccount("/disclosure/self", requireAccount(accountLogin, "disclosureApi.getSelfPresence")),
    ),
  setSelfPresence: (accountLogin: string, isPublic: boolean) =>
    api.post<{ public: boolean }>(
      withAccount("/disclosure/self", requireAccount(accountLogin, "disclosureApi.setSelfPresence")),
      { public: isPublic },
    ),
};

// UserVisibility is the D-07 display-layer flag a member sets for themselves.
export type UserVisibility = "full" | "anonymized" | "redacted";
